import { u as i } from "./chunk-DMO4EI7P-70e4c539.js";
import { f as c, o as r, a as m, c as l } from "./chunk-KRPLQIP4-1ae0870d.js";
import "@emotion/react";
import { j as x } from "./jsx-runtime-721af1ab.js";
function f(e) {
  const t = Object.assign({}, e);
  for (let a in t)
    t[a] === void 0 && delete t[a];
  return t;
}
var g = c(function(t, a) {
  const s = i("Text", t), { className: d, align: u, decoration: T, casing: j, ...o } = r(t), n = f({
    textAlign: t.align,
    textDecoration: t.decoration,
    textTransform: t.casing
  });
  return /* @__PURE__ */ x.jsx(
    m.p,
    {
      ref: a,
      className: l("chakra-text", t.className),
      ...n,
      ...o,
      __css: s
    }
  );
});
g.displayName = "Text";
export {
  g as T
};
